import {
  Box,
  Container,
  Grid,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";

// icons
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DashBoardPageHeaderPage from "../components/DashBoard/DashBoardHeaderPage";
import ShipmentReport from "../components/ShipmentReport";
import ItemHistoryReport from "../components/ItemHistoryReport";
import StorageReport from "../components/StorageReport";
import FaultyReport from "../components/FaultyReport";
import ProcessedReport from "../components/ProcessedReport";
import TotalStockReport from "./TotalStockReport";
import FormSelect from "../forms/FormSelect";
import { useFormik } from "formik";
import URLS from "../services/urlConstants";
import { get, post } from "../services/apiMethods";
import { LoadingButton } from "@mui/lab";
import FileSelect from "../forms/FileSelect";
import PageHeader from "../components/PageHeader";
import { Download } from "@mui/icons-material";
import themeData from "../data/themeData";
import { downloadExcel } from "../utils/utilities";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import AuditReportDownload from "../components/AuditReportDownload";

export default function AuditReports() {
  const [warehouseData, setWarehouseData] = useState([]);
  const [palletCodeList, setPalletCodeList] = useState([]);
  const [loadingWarehouse, setLoadingWarehouse] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectFile, setSelectFile] = useState([]);
  const [summaryData, setSummaryData] = useState(null);

  // { GP1 : [msn.msn], GP1: [msn] }

  const [palletSummary, setPalletSummary] = useState([
    {
      GP1: {
        totalItemsAsPerSystem: 0,
        totalItemsScanned: 0,
        totalMisMatch: [{ msn: "", itemDescription: "" }],
        tallied: "yes",
      },
      GP2: {
        totalItemsAsPerSystem: 0,
        totalItemsScanned: 0,
        totalMisMatch: [{ msn: "", itemDescription: "" }],
        tallied: "no",
      },
    },
  ]);

  const [stockSummary, setStockSummary] = useState({
    totalItemsScanned: 0,
    totaltemsFound: 0,
    totalExtraItems: ["msn"],
    totalMissingItems: ["msn"],
  });

  const getWarehouseDetails = async () => {
    try {
      const { data } = await get(URLS.warehouse.list);
      setWarehouseData(
        data?.result.map((w) => ({
          ...w,
          label: `${w.code}`,
          value: w._id,
        }))
      );
    } catch (error) {
      console.log(error);
    }
  };

  const getPalletCode = async () => {
    try {
      const { data } = await get(URLS.palletCode.list, {
        params: { search: { warehouse: formik.values.warehouse } },
      });

      let result = [
        { label: "All", value: "All" },
        ...data?.result.map((w) => ({
          ...w,
          label: w.code,
          value: w._id,
        })),
      ];

      setPalletCodeList(result);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangeFiles = (e, index) => {
    const { files } = e.target;
    let fileList = [];
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        fileList.push(file);
      }
      setSelectFile(fileList);
    } else {
      console.log("No files selected");
    }
  };

  const handleRemoveFile = (fileName, index) => {
    setSelectFile(selectFile.filter((file) => file.name != fileName));
  };

  useEffect(() => {
    getWarehouseDetails();
  }, []);

  const handleDownloadSampleAuditFile = async () => {
    let selectedPalletCodes = formik.values.palletCodeIds;

    try {
      if (!formik.values.warehouse)
        return toast.info("Please select a warehouse!");
      setLoadingWarehouse(true);
      const { data, status } = await get(URLS.items.downloadSampleAuditFile, {
        params: {
          warehouseId: formik.values.warehouse,
          palletCodeIds: selectedPalletCodes,
        },
        responseType: "blob",
        validateStatus: (status) => status < 500,
      });
      if (status === 200) {
        downloadExcel(data, "Audit_Report.xlsx");
      } else {
        const errorText = await new Response(data).text();
        toast.error(JSON.parse(errorText)?.message);
      }
      setLoadingWarehouse(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleCheckAuditReport = async (e) => {
    if (!formik.values.warehouse)
      return toast.info(
        "Please select the warehouse you downloaded sample file of!"
      );
    e.preventDefault();

    const formData = new FormData();

    selectFile.forEach((file) => {
      formData.append("file", file);
    });

    formData.append("warehouseId", formik.values.warehouse);

    try {
      setLoading(true);

      const { data, status } = await post(
        URLS.items.checkAuditReport,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log(data.result, "====result s");
      setSummaryData(data.result);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const formik = useFormik({
    initialValues: {
      warehouse: "",
      palletCodeIds: [],
    },
    onSubmit: (values) => console.log(values),
    enableReinitialize: true,
  });

  useEffect(() => {
    if (formik.values.warehouse) {
      getPalletCode();
    }
  }, [formik.values.warehouse]);

  return (
    <Container sx={{ alignItems: "center" }}>
      <PageHeader
        title="Audit Reports"
        addButtonDisabled={true}
        showAdd={false}
        showAddField={false}
      />
      <Stack spacing={3}>
        {/* Sample File Section */}
        <Paper sx={{ width: "100%", mx: "auto", p: 2 }}>
          <Typography
            variant="h6"
            sx={{
              mb: 2,
              backgroundColor: "#f1f1f18f",
              p: 1,
              color: "black",
            }}
          >
            Download Sample File
          </Typography>

          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={4}>
              <FormSelect
                options={warehouseData}
                formik={formik}
                name="warehouse"
                label="Select Warehouse"
                required={true}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormSelect
                options={palletCodeList}
                formik={formik}
                name="palletCodeIds"
                label="Select Pallet Code"
                required={true}
                multiple={true}
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <LoadingButton
                fullWidth
                loading={loadingWarehouse}
                variant="contained"
                size="small"
                startIcon={<Download />}
                onClick={handleDownloadSampleAuditFile}
              >
                Download
              </LoadingButton>
            </Grid>
          </Grid>
        </Paper>

        {/* Report Download Section */}
        <Paper sx={{ width: "100%", mx: "auto", p: 2 }}>
          <Typography
            variant="h6"
            sx={{
              mb: 2,
              backgroundColor: "#f1f1f18f",
              p: 1,
              color: "black",
            }}
          >
            Download Report
          </Typography>

          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={8}>
              <FileSelect
                name="uploadFile"
                onChange={(e) => handleChangeFiles(e)}
                customOnChange={true}
                label="Select File"
                selectedFiles={selectFile}
                onRemove={(fileName) => handleRemoveFile(fileName)}
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <LoadingButton
                fullWidth
                loading={loading}
                variant="contained"
                size="small"
                // startIcon={<Download />}
                onClick={handleCheckAuditReport}
              >
                Check
              </LoadingButton>
            </Grid>
          </Grid>
        </Paper>
      </Stack>

      {summaryData ? <AuditReportDownload data={summaryData} /> : null}
    </Container>
  );
}
